import type { Language } from "../shared/contracts";
export const categories = [
  "community",
  "learning",
  "culture",
  "language",
  "wellbeing",
];
const labels: Record<string, [string, string]> = {
  ja: ["日本語", "日语"],
  zh: ["中文", "中文"],
  "ja/en": ["日本語・English", "日语・英语"],
  creative: ["学び・ワークショップ", "学习工作坊"],
  community: ["地域・交流", "社区交流"],
  learning: ["学び・ワークショップ", "学习工作坊"],
  culture: ["文化・アート", "文化艺术"],
  language: ["言語・国際交流", "语言与国际交流"],
  wellbeing: ["暮らし・ウェルビーイング", "生活与身心健康"],
  draft: ["下書き", "草稿"],
  awaiting_venue: ["会場確認中", "场地待审批"],
  published: ["開催確定", "举办时间已确认"],
  polling: ["日程回答受付中", "征集可参加时间"],
  awaiting_final: ["開催日時を調整中", "等待主办方确定时间"],
  cancelled: ["中止", "已取消"],
  preregistered: ["日程回答済み", "已提交时间意向"],
  invited: ["参加確認が必要", "待确认参加"],
  reschedule_pending: ["変更後の日程を要確認", "待确认变更后的时间"],
  confirmed: ["参加確定", "报名成功"],
  waitlisted: ["キャンセル待ち", "候补中"],
  mismatch: ["選択した日程では開催されません", "最终时间与意向不符"],
  withdrawn: ["辞退済み", "已退出"],
  expired: ["確認期限終了", "确认已过期"],
  pending: ["未処理", "待处理"],
  approved: ["承認済み", "已批准"],
  linked: ["活動へ移管済み", "已关联活动"],
  rejected: ["差戻し", "已拒绝"],
  superseded: ["失効", "已失效"],
  local: ["ローカル保管", "本地保存"],
  accepted: ["メールサーバー受付済み", "邮件服务器已接受"],
  failed: ["送信失敗", "发送失败"],
  suppressed: ["現在の状態と一致しないため送信停止", "内容已过时，停止发送"],
};
export function label(key: string, language: Language) {
  return labels[key]?.[language === "ja" ? 0 : 1] ?? key;
}
export function date(
  value: string | null | undefined,
  language: Language,
  options: Intl.DateTimeFormatOptions = {
    month: "short",
    day: "numeric",
    weekday: "short",
    hour: "2-digit",
    minute: "2-digit",
  },
) {
  return value
    ? new Intl.DateTimeFormat(language === "ja" ? "ja-JP" : "zh-CN", {
        timeZone: "Asia/Tokyo",
        ...options,
      }).format(new Date(value))
    : "";
}
export function toInput(value: string) {
  return new Date(Date.parse(value) + 9 * 3600000).toISOString().slice(0, 16);
}
export function toISO(value: string) {
  return new Date(value + ":00+09:00").toISOString();
}
export function futureInput(days: number, hour = 14) {
  const d = new Date(Date.now() + days * 86400000 + 9 * 3600000);
  d.setUTCHours(hour, 0, 0, 0);
  return d.toISOString().slice(0, 16);
}
